import { type ApiResultPromise, normalizeApiError } from "@/api/errors"
import { Err, Ok } from "@/util/result"

/**
 * Wrap a `caseConverterClient` (or any other Promise that resolves to `{ data: T }`)
 * in a `Result` so callers don't need their own `try/catch`/`normalizeApiError`.
 *
 * Accepts either a promise or a thunk so callers with synchronous payload setup
 * (e.g. `humps.decamelizeKeys`) can also wrap the whole call.
 */
export async function apiResult<T>(
  call: Promise<{ data: T }> | (() => Promise<{ data: T }>),
  fallbackMessage: string,
): ApiResultPromise<T> {
  try {
    const promise = typeof call === "function" ? call() : call
    const { data } = await promise
    return Ok(data)
  } catch (err) {
    return Err(normalizeApiError(err, fallbackMessage))
  }
}
